import type { FlyingItem } from "./expandBurst";

/**
 * Потолок значков в слое полёта. Удаляет их onAnimationEnd, а в скрытой
 * вкладке или при сбое анимации события не приходят: без потолка массив
 * рос бы без предела.
 */
export const MAX_FLYING_ITEMS = 60;

/**
 * Новые значки в конец, старые сверх потолка отбрасываются. В скрытой
 * вкладке не добавляем ничего: анимации там не идут, и при возврате
 * разом всплыла бы вся накопленная пачка.
 */
export function appendFlyingItems(
  prev: FlyingItem[],
  added: FlyingItem[],
  { hidden }: { hidden: boolean },
): FlyingItem[] {
  if (hidden || added.length === 0) return prev;
  const next = [...prev, ...added];
  return next.length > MAX_FLYING_ITEMS
    ? next.slice(next.length - MAX_FLYING_ITEMS)
    : next;
}
